<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        Welcome Conversation Menu
        <small>Create and manage welcome menu messages</small>
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li class="active">Welcome Conversation Menu</li>
      </ol>
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="row">
        <div class="col-xs-12">
          <div class="box">
            <div class="box-body">
              <div class="col-xs-12 col-lg-10 col-lg-offset-1">
                <New />

                <All />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.row -->
    </section>
    <!-- /.content -->
  </div>
</template>

<script>
import All from './all'
import New from './new'

export default {
  name: 'Menu',
  components: {
    All,
    New
  }
}
</script>




// WEBPACK FOOTER //
// index.vue?97028208